import React from 'react';
import { Heading } from 'src/components/atoms/heading';

export const FormHeading: React.FC = ({ children }) => (
  <div className="m-form-heading">
    <Heading level="h1">{children}</Heading>
    {/*<hr className="m-form-heading__separator" />*/}
  </div>
);
